export const KEY_TYPES = [
  {
    id: "single",
    title: "Одноразовый ключ",
    summary:
      "Покупаете ключи и выдаёте каждому ученику отдельно — при продаже курса или в личном порядке.",
    audience: "Авторы курсов, эксперты, репетиторы, инфобизнес",
    points: [
      "Один ключ — один человек на один сценарий",
      "Ключи не сгорают, пока не использованы",
      "Цену доступа для ученика определяете вы",
    ],
  },
  {
    id: "group",
    title: "Групповой доступ",
    summary:
      "Оформляете подписку по размеру команды — сотрудники проходят сценарий по общей ссылке.",
    audience: "Компании, HR, руководители отделов",
    points: [
      "Одна ссылка на всю команду в Telegram",
      "Без персональных ключей на каждого",
      "Подписка на 30 дней, продление вручную",
    ],
  },
];

export const PRICING_SECTIONS = [
  {
    id: "single-keys",
    keyType: "single",
    title: "Пакеты одноразовых ключей",
    plans: [
      {
        packageId: "l_start",
        title: "Старт",
        price: 490,
        badge: "5 ключей",
        perUnit: "98 ₽ / ключ",
        features: [
          "5 одноразовых ключей",
          "Редактор без ограничений",
          "Публикация в Telegram",
        ],
        highlight: false,
      },
      {
        packageId: "l_basic",
        title: "Базовый",
        price: 1490,
        badge: "20 ключей",
        perUnit: "75 ₽ / ключ",
        features: [
          "20 одноразовых ключей",
          "Выгоднее на 23%",
          "Для регулярных запусков",
        ],
        highlight: true,
      },
      {
        packageId: "l_pro",
        title: "Автор",
        price: 3490,
        badge: "50 ключей",
        perUnit: "70 ₽ / ключ",
        features: [
          "50 одноразовых ключей",
          "Для активных авторов",
          "Максимальная выгода в линейке",
        ],
        highlight: false,
      },
      {
        packageId: "l_wholesale",
        title: "Опт",
        price: 8990,
        badge: "150 ключей",
        perUnit: "60 ₽ / ключ",
        features: [
          "150 одноразовых ключей",
          "Для школ и продюсеров",
          "Минимальная себестоимость",
        ],
        highlight: false,
      },
    ],
  },
  {
    id: "group-access",
    keyType: "group",
    title: "Групповой доступ для бизнеса",
    plans: [
      {
        packageId: "biz_s_15",
        title: "Микрокоманда",
        price: 4990,
        pricePeriod: "/ мес",
        badge: "Групповой доступ",
        perUnit: "До 15 сотрудников",
        segmentLabel: "1–15 чел.",
        features: [
          "30 дней подписки",
          "Ссылка для всей команды",
          "Онбординг и инструктаж",
        ],
        highlight: false,
      },
      {
        packageId: "biz_m_50",
        title: "Отдел",
        price: 9990,
        pricePeriod: "/ мес",
        badge: "Групповой доступ",
        perUnit: "16–50 сотрудников",
        segmentLabel: "16–50 чел.",
        features: [
          "30 дней подписки",
          "Несколько сценариев",
          "Обучение отдела",
        ],
        highlight: true,
      },
      {
        packageId: "biz_l_100",
        title: "Компания",
        price: 14990,
        pricePeriod: "/ мес",
        badge: "Групповой доступ",
        perUnit: "51–100 сотрудников",
        segmentLabel: "51–100 чел.",
        features: [
          "30 дней подписки",
          "Программы по подразделениям",
          "Для HR и L&D",
        ],
        highlight: false,
      },
      {
        packageId: "enterprise_contact",
        title: "Крупный бизнес",
        contactOnly: true,
        badge: "По запросу",
        perUnit: "От 100 сотрудников",
        segmentLabel: "100+ чел.",
        features: [
          "Индивидуальные условия",
          "Счёт для юрлица",
          "support@club-lab.ru",
        ],
        highlight: false,
      },
    ],
  },
];

export const PRICING_FAQ = [
  {
    question: "Какой тип доступа мне нужен?",
    answer:
      "Если вы продаёте курс и выдаёте доступ каждому ученику отдельно — одноразовые ключи. Если обучаете команду или отдел по одной ссылке — групповой доступ.",
  },
  {
    question: "Можно ли использовать оба типа?",
    answer:
      "Да. Для одних сценариев — индивидуальный режим с одноразовыми ключами, для других — групповой доступ по подписке.",
  },
  {
    question: "Есть ли бесплатные ключи при регистрации?",
    answer:
      "Нет. Редактор доступен в демо-режиме, а для публикации и выдачи доступа нужно выбрать тариф.",
  },
];
